var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page",attrs:{"role":"main"}},[_c('Hero',{attrs:{"head":_vm.head,"subhead":_vm.subhead}}),_c('div',{staticClass:"page__content"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }